import React from 'react';

class Button extends React.Component {

   render() {
      return (
         <button {...this.props} className="btn">
            {this.props.title}
         </button>
      );
   }
}

export default Button


// WEBPACK FOOTER //
// ./src/component/Button.js